import React from 'react';

import EmptyBlock from 'src/routes/Hotel/components/EmptyBlock';
import { useTranslation } from '@lt/localization';

import type { NoCoordinatesMapProps as Props } from './types';

const NoCoordinatesMap = ({
  className = '',
  isMobile = false,
  location,
}: Props) => {
  const { t } = useTranslation();

  return (
    <EmptyBlock
      className={className}
      isMobile={isMobile}
      title={t('map.noCoords.title')}
      description={t('map.noCoords.description', { location })}
    />
  );
};

export default NoCoordinatesMap;
